/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Typography } from '@material-ui/core';
import AppContext from '../AppContext';
import { withTranslation } from 'react-i18next';

class Logout extends Component {
    constructor(props) {
        super(props);
        this.state = { redirect: false };
    }

    componentDidMount() {
        AppContext.logout()
            .then(() => {
                window.location.href = '/';
            });
    }

    render() {
        return <Typography variant="title">{this.props.t('Kirjaudutaan ulos')}..</Typography>;
    }
}

export default withTranslation()(Logout);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Logout.js